// consoles/ems/EmsConsole.js —— 能源管家控制台
// 严格依据《云平台（能源管家）需求文档》2.7 单站监控组织 tab 集合：
// 首页 / 主接线图（单一接线图） / 设备监控 / 故障告警 / 曲线报表 / 策略管理 / 系统管理
// 本类型独有：智能策略、视频监控、消防设备（联动环）；
// 设备控制（PCS 开关机 / 复归、空调开关机）位于「设备监控」内并需二次口令。
import React, { useState } from 'react';
import ScrollTabs from '../../../../components/ScrollTabs';
import { LangContext, t } from './langContext';
import EmsHome from '../../panels/ems/EmsHome';
import EmsWiring from '../../panels/ems/EmsWiring';
import EmsDevice from '../../panels/ems/EmsDevice';
import EmsAlarm from '../../panels/ems/EmsAlarm';
import EmsCurve from '../../panels/ems/EmsCurve';
import EmsStrategy from '../../panels/ems/EmsStrategy';
import EmsSystem from '../../panels/ems/EmsSystem';

const EmsConsole = ({ station, unlocked, gate }) => {
  const [tab, setTab] = useState('home');
  const [lang, setLang] = useState('zh');

  const items = [
    { key: 'home', label: t(lang, '首页', 'Home'), children: <EmsHome station={station} /> },
    { key: 'wiring', label: t(lang, '主接线图', 'Wiring Diagram'), children: <EmsWiring station={station} /> },
    {
      key: 'device',
      label: t(lang, '设备监控', 'Device Monitor'),
      // 能源管家把设备控制放在设备监控内，故需二次口令
      children: <EmsDevice station={station} unlocked={unlocked} gate={gate} />,
    },
    { key: 'alarm', label: t(lang, '故障告警', 'Alarms'), children: <EmsAlarm station={station} /> },
    { key: 'curve', label: t(lang, '曲线报表', 'Curve Reports'), children: <EmsCurve station={station} /> },
    { key: 'strategy', label: t(lang, '策略管理', 'Strategy'), children: <EmsStrategy station={station} /> },
    { key: 'system', label: t(lang, '系统管理', 'System'), children: <EmsSystem station={station} /> },
  ];

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <div className="panel sm-tabs">
        <ScrollTabs activeKey={tab} onChange={setTab} items={items} />
      </div>
    </LangContext.Provider>
  );
};

export default EmsConsole;
